import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AppToastService } from "src/app/core/services/app-toast.service";
import { UtilsService } from "src/app/core/services/utils.service";
import { IUploadedDocument } from "../documents.models";

@Component({
  selector: "app-id-card",
  templateUrl: "./id-card.component.html",
  styleUrls: ["./id-card.component.scss"],
})
export class IdCardComponent implements OnChanges {
  idCardForm: FormGroup;
  frontDocumentFile: any;
  frontDocumentFileExtension: any;
  backDocumentFile: any;
  backDocumentFileExtension: any;

  loadFrontDocumentFile: any;
  loadBackDocumentFile: any;

  RGValidPattern = /^\d{1,2}\.\d{3}\.\d{3}-\d{1}|^\d{9}$/;

  @Input() idCardValue;
  @Input() ufs;
  @Input() isExhibition = false;
  @Input() isConsult = false;

  @Output() formValue: EventEmitter<any> = new EventEmitter();
  @Output() downloadEvent: EventEmitter<IUploadedDocument> = new EventEmitter();
  frontDocumentSasUrl: string;
  backDocumentSasUrl: string;

  constructor(
    private fb: FormBuilder,
    private toast: AppToastService,
    private utilsService: UtilsService
  ) {
    this.buildForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.idCardForm) this.buildForm();

    this.loadData(changes);
  }

  loadData(changes: SimpleChanges) {
    const data = changes.idCardValue?.currentValue;

    if (data) {
      this.idCardForm?.patchValue({
        issueDate: data.dateIssue?.split(" ")[0],
        issuingAgency: data.issuingAgency,
        countryId: data.countryId,
      });

      this.frontDocumentSasUrl = data.frontOfDocument;
      this.frontDocumentFileExtension = `${data.frontOfDocumentExtension}`;
      this.backDocumentSasUrl = data.backOfDocument;
      this.backDocumentFileExtension = `${data.backOfDocumentExtension}`;
    }
  }

  buildForm() {
    this.idCardForm = this.fb.group({
      issueDate: [
        { value: "", disabled: this.isExhibition },
        Validators.required,
      ],
      issuingAgency: [
        { value: "", disabled: this.isExhibition },
        Validators.required,
      ],
      countryId: [
        { value: null, disabled: this.isExhibition },
        Validators.required,
      ],
    });
  }

  isInvalidField(field: string): boolean | undefined {
    const formField = this.idCardForm.get(field);
    return formField?.invalid && formField?.touched;
  }

  getFrontDocumentFile(event) {
    this.frontDocumentFile = event.base64;
    this.frontDocumentFileExtension = event.extension;
  }

  getBackDocumentFile(event) {
    this.backDocumentFile = event.base64;
    this.backDocumentFileExtension = event.extension;
  }

  idFormValueEmit() {
    this.idCardForm.markAllAsTouched();

    if (
      this.idCardForm.invalid ||
      !this.frontDocumentFile ||
      !this.backDocumentFile
    ) {
      this.toast.show(
        "Validação de formulário",
        "Informações obrigatórias não preenchidas. Revise os campos e salve novamente."
      );
      return;
    }

    const idCardFormValue = {
      ...this.idCardForm.getRawValue(),
      frontDocumentFile: this.frontDocumentFile,
      frontDocumentFileExtension: this.frontDocumentFileExtension,
      backDocumentFile: this.backDocumentFile,
      backDocumentFileExtension: this.backDocumentFileExtension,
    };

    this.formValue.emit(idCardFormValue);
  }

  downloadFile() {
    if (this.frontDocumentSasUrl) {
      const frontDocument: IUploadedDocument = {
        extension: this.frontDocumentFileExtension,
        sasUrl: this.frontDocumentSasUrl,
        fileName: `RG_FRENTE.${this.frontDocumentFileExtension}`,
      };
      this.downloadEvent.emit(frontDocument);
    }

    if (this.backDocumentSasUrl) {
      const backDocument: IUploadedDocument = {
        extension: this.backDocumentFileExtension,
        sasUrl: this.backDocumentSasUrl,
        fileName: `RG_VERSO.${this.backDocumentFileExtension}`,
      };
      this.downloadEvent.emit(backDocument);
    }

    // if (this.frontDocumentFile && this.frontDocumentFile !== "null")
    //   this.utilsService.downloadFile(this.frontDocumentFile, `RG_FRENTE.${this.frontDocumentFileExtension}`);

    // if (this.backDocumentFile && this.backDocumentFile !== "null")
    //   this.utilsService.downloadFile(this.backDocumentFile, `RG_VERSO.${this.backDocumentFileExtension}`);
  }
}
